export default "__VITE_ASSET__cdodM_4s__"